import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  padding: 0 1.2rem;

  h2 {
    text-align: center;
    font-size: 5rem;
    margin-bottom: 2.5rem;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.6rem;

    .project {
      padding: 1.6rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #fff;

      &:hover {
        cursor: pointer;
        transform: translateY(-5px);
        background-color: var(--pink);
        color: var(--green);
      }

      header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--blue);
        margin-bottom: 2.4rem;

        .project-links {
          display: flex;
          align-items: center;
          gap: 0.8rem;
        }

        a > img {
          width: 4.2rem;
        }
      }

      h3 {
        margin-bottom: 1.5rem;
        font-size: 1.8rem;
      }

      p {
        letter-spacing: 0.08rem;
        margin-bottom: 1.5rem;
        font-size: 1.4rem;

        a {
          color: #ffff;
          border-bottom: 1px solid var(--green);
          transition: color 0.25s;

          &:hover {
            cursor: pointer;
            color: var(--green);
          }
        }
      }

      .metrics {
        margin: 2rem 0;
        
        .metrics-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--green);
          margin-bottom: 1.2rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .metrics-grid {
          display: grid;
          gap: 1rem;
          
          .metric-card {
            background: rgba(124, 58, 237, 0.1);
            border: 1px solid rgba(124, 58, 237, 0.3);
            border-radius: 8px;
            padding: 1rem 1.2rem;
            display: flex;
            align-items: flex-start;
            gap: 1rem;
            transition: all 0.3s ease;
            
            &:hover {
              background: rgba(124, 58, 237, 0.2);
              border-color: rgba(124, 58, 237, 0.5);
              transform: translateX(4px);
            }
            
            .metric-icon {
              flex-shrink: 0;
              width: 2rem;
              height: 2rem;
              background: var(--green);
              color: #000;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 1.2rem;
            }
            
            .metric-text {
              font-size: 1.3rem;
              line-height: 1.5;
              flex: 1;
            }
          }
        }
      }

      footer {
        margin-top: auto;

        .tech-list {
          display: flex;
          flex-wrap: wrap;
          gap: 1.2rem;
          font-size: 1.5rem;
          font: bold;
          opacity: 0.6;
          color: var(--green)
        }
      }
    }
  }

  @media (max-width: 960px) {
    .projects {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 740px) {
    h2 {
      font-size: 2.4rem;
    }

    .projects {
      grid-template-columns: 1fr;
    }

    .project {
      padding: 1.2rem;
    }
  }
`;
